import React, { useEffect, useState } from 'react';
import { CreditCard } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import api from '@/lib/axios';
import { remainingHoursLabel, cardStandLabel } from '@/lib/prepaidCards';
import { statusLabel } from '@/lib/deLabels';

export default function StudentPrepaidCards({ studentId }) {
  const [cards, setCards] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    if (!studentId) return undefined;
    let cancelled = false;
    setLoading(true);
    api.get('/prepaid-cards', { params: { student_id: studentId, limit: 100 } })
      .then((r) => { if (!cancelled) setCards(r.data || []); })
      .catch(() => { if (!cancelled) setCards([]); })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, [studentId]);

  if (loading) {
    return <p className="text-sm text-slate-500" data-testid="student-prepaid-loading">Karten werden geladen…</p>;
  }
  if (cards.length === 0) {
    return <p className="text-sm text-slate-500" data-testid="student-prepaid-empty">Keine Prepaid-Karten</p>;
  }

  return (
    <div className="space-y-3" data-testid="student-prepaid-cards">
      {cards.map((card) => (
        <div
          key={card.id}
          className="flex items-center justify-between gap-3 rounded-lg border border-slate-200 bg-white p-3"
          data-testid={`student-prepaid-${card.id}`}
        >
          <div className="flex items-start gap-3 min-w-0">
            <div className="p-2 rounded-lg bg-brand-red/5 shrink-0">
              <CreditCard className="w-4 h-4 text-brand-red" />
            </div>
            <div className="min-w-0">
              <p className="text-sm font-semibold text-slate-800 truncate">{card.name}</p>
              <p className="text-xs text-slate-500 mt-0.5">{cardStandLabel(card)}</p>
              <p className="text-sm font-medium text-slate-800 mt-1" data-testid={`student-prepaid-remaining-${card.id}`}>
                {remainingHoursLabel(card.remaining_units, card.unit_duration_minutes)}
              </p>
            </div>
          </div>
          <Badge className={card.status === 'active'
            ? 'bg-emerald-50 text-emerald-700 border-emerald-200'
            : 'bg-slate-100 text-slate-600'}>
            {card.status === 'active' ? 'Laufend' : statusLabel(card.status)}
          </Badge>
        </div>
      ))}
    </div>
  );
}
